export default class DetailsOfCharges {
  id = 1;
  name = "-";
}
